import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShipMessage } from "../types/ShipMessage";
import { useAuth } from "@clerk/react";
import { isAdminUser } from "../data/adminUsers";

type MessageProps = {
  messageData: ShipMessage[] | null;
};

function ShipMessageBoard({ messageData }: MessageProps) {
  const [currentShipIndex, setCurrentShipIndex] = useState(0);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const { isLoaded, has, userId } = useAuth();
  const isCaptain = isLoaded && (has({ plan: "vessel_vibes_captain" }) || isAdminUser(userId));

  const currentShip = messageData ? messageData[currentShipIndex] : null;
  const messages = currentShip ? currentShip.messages : [];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => {
        const nextIndex = prev + 1;
        if (nextIndex >= messages.length) {
          const nextShipIndex = messageData ? (currentShipIndex + 1) % messageData.length : 0;
          setCurrentShipIndex(nextShipIndex);
          return 0;
        }
        return nextIndex;
      });
    }, 8000);
    return () => clearInterval(interval);
  }, [currentShipIndex, messages.length]);

  return (
    <div className="relative w-80 h-24 bg-black rounded-md border border-cyan-500 overflow-hidden p-2">
      <div className="text-cyan-400 text-xs font-bold uppercase mb-1 text-center tracking-wider">
        Bridge Operations Feed
      </div>

      <div className="text-white text-xs text-center mb-2 font-bold">
        {currentShip?.shipName}
      </div>

      <div className="relative h-8 flex items-center justify-center">
        {isCaptain ? (
          <AnimatePresence mode="wait">
            <motion.div
              key={currentMessageIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.8 }}
              className="text-green-400 text-[10px] text-center px-2"
            >
              {messages[currentMessageIndex]}
            </motion.div>
          </AnimatePresence>
        ) : (
          <a href="/captain" className="text-[10px] text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer">
            🔒 Captain Access to unlock
          </a>
        )}
      </div>
    </div>
  );
}

export default ShipMessageBoard;
